import { Extension as e } from "../../node_modules/@tiptap/core/dist/index.mjs";
import { unsetTextStyleAttribute as n } from "../text-style-extension/utils/unset-text-style-attribute.mjs";
const l = e.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (r) => r.style.backgroundColor,
            renderHTML: (r) => r.backgroundColor ? {
              style: `background-color: ${r.backgroundColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (r) => ({ chain: o }) => o().setMark("textStyle", { backgroundColor: r }).run(),
      unsetBackgroundColor: () => ({ tr: r, state: o, dispatch: t }) => n("backgroundColor", o, r, t)
    };
  }
});
export {
  l as TextBackgroundColor
};
